import { INemSmsContactDetails } from '../interfaces';
import * as api from './middleware/api.middleware';

const serviceUrl = '/contactsservice/v2/contacts';

const classicLogonPlace = localStorage.getItem('classicLogonPlace');

export function getContact() {
    return api.get<INemSmsContactDetails[]>(serviceUrl);
}

export function getNemSmsContact(cprCvr: string[]) {
    const postData = classicLogonPlace === 'privat' ? { cprNumber: cprCvr } : { cvrNumber: cprCvr };
    return api.post<INemSmsContactDetails[]>(serviceUrl, postData);
}

export const updateNemSmsContact = (postData: any, contactId: string): Promise<INemSmsContactDetails> => {
    return api.put<INemSmsContactDetails>(`${serviceUrl}/${contactId}`, postData);
};

export const confirmNemSmsContact = (
    postData: any,
    contactId: string,
    nemSmsId: string
): Promise<INemSmsContactDetails> => {
    return api.put<INemSmsContactDetails>(`${serviceUrl}/${contactId}/verifications/${nemSmsId}`, postData);
};
